// Types and constants local to the Ashtakvarga calculator widget.

export interface AshtakvargaRequest {
  name: string;
  birth_date: string;
  birth_time?: string | null;
  birth_place: string;
  latitude?: number | null;
  longitude?: number | null;
  timezone?: string | null;
}

export interface PredictionItem {
  house: number;
  house_name: string;
  sav: number;
  strength: "very_strong" | "average" | "below_average" | "weak";
  summary: string;
}

export interface AshtakvargaResponse {
  sarvashtakvarga_table: number[];
  sign_names: string[];
  planet_ashtakvarga_tables: Record<string, number[]>;
  planet_display_en: Record<string, string>;
  bindu_totals_per_house: number[];
  total_bindus: Record<string, number>;
  planet_strength: Record<string, string>;
  predictions: PredictionItem[];
}

export const LOADING_STEPS = [
  "Finding your birth location...",
  "Computing planetary longitudes...",
  "Building Bhinnashtakvarga tables...",
  "Calculating Sarvashtakvarga...",
];

export const STEP_DELAY_MS = 1200;

export const STRENGTH_CONFIG = {
  very_strong: {
    label: "Very Strong",
    textClass: "text-success",
    surfaceClass: "bg-success/10",
  },
  average: {
    label: "Average",
    textClass: "text-intent-brand",
    surfaceClass: "bg-surface-brand-subtle",
  },
  below_average: {
    label: "Below Average",
    textClass: "text-warning",
    surfaceClass: "bg-warning/10",
  },
  weak: { label: "Weak", textClass: "text-error", surfaceClass: "bg-error/10" },
};

export const PLANET_ORDER = ["sun", "moon", "mars", "mercury", "jupiter", "venus", "saturn"];
